import React from 'react';
import classes from './Logo.module.css';

const logo = (props) => {
  const imageLogo = props.white ? [classes.Logo, classes.WhiteLogo].join(' ') : classes.Logo;
  let styles = imageLogo;
  if (props.small) {
    styles = [imageLogo, classes.LogoSmall].join(' ');
  } else if (props.navbar) {
    styles = [imageLogo, classes.LogoNavbar].join(' ');
  }
  return (
    <div className={styles} style={props.style} onClick={props.clicked}>
      <svg className={classes.LogoIcon}>
        <use xlinkHref='#icon-logo' />
      </svg>
    </div>
  );
};
export default logo;



// WEBPACK FOOTER //
// ./src/components/UI/Logo/Logo.js